import _slicedToArray from "/opt/build/repo/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
// src/index.ts
import { useEffect, useState } from "react";
import { useEventListener } from "@chakra-ui/react-use-event-listener";
import { getOwnerWindow } from "@chakra-ui/dom-utils";

function useAnimationState(props) {
  var isOpen = props.isOpen,
      ref = props.ref;

  var _useState = useState(isOpen),
      _useState2 = _slicedToArray(_useState, 2),
      mounted = _useState2[0],
      setMounted = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      once = _useState4[0],
      setOnce = _useState4[1];

  useEffect(function () {
    if (!once) {
      setMounted(isOpen);
      setOnce(true);
    }
  }, [isOpen, once, mounted]);
  useEventListener(function () {
    return ref.current;
  }, "animationend", function () {
    setMounted(isOpen);
  });
  var hidden = isOpen ? false : !mounted;
  return {
    present: !hidden,
    onComplete: function onComplete() {
      var _a;

      var win = getOwnerWindow(ref.current);
      var evt = new win.CustomEvent("animationend", {
        bubbles: true
      });
      (_a = ref.current) == null ? void 0 : _a.dispatchEvent(evt);
    }
  };
}

export { useAnimationState };